import React from 'react';
import { useIsLoggedIn } from '@cp/entities/currentUser';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { BellFilledIcon, CloseIcon } from '@cp/ds/src/icons';
import { useTheme } from '@cp/ds/src/hooks';
import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds';
import { Button } from '@cp/ds/src/components/button';
import { PushNotificationsStatus, usePushNotifications } from 'src/shared/pushNotifications';
import { useIsEmbedded, useIsIOS } from 'src/shared/mediaQueries';
import { useTracking } from 'src/shared/tracking';
import { notificationBannerClick, notificationEnabled } from '../lib';

let isClosedGlobal = false;

export interface NotificationsSubscribeBannerProps {}
export const NotificationsSubscribeBanner: React.FC<NotificationsSubscribeBannerProps> = ({}) => {
  const theme = useTheme();
  const isEmbedded = useIsEmbedded();
  const isLoggedIn = useIsLoggedIn();
  const isIOS = useIsIOS();
  const pushNotifications = usePushNotifications();
  const [isLoading, setLoading] = React.useState(false);
  const [isClosed, setClosed] = React.useState(isClosedGlobal);
  const trackClick = useTracking(notificationBannerClick);
  const trackEnabled = useTracking(notificationEnabled);

  if (
    isEmbedded ||
    isClosed ||
    !isLoggedIn ||
    isIOS ||
    ![PushNotificationsStatus.NotSubscribed, PushNotificationsStatus.AddingToHomeScreenRequired].includes(pushNotifications.status)
  ) {
    return null;
  }

  return (
    <Stack
      alignItems="center"
      direction="row"
      sx={{
        opacity: isLoading ? 0.5 : 1,
        px: { xs: 1.5, [MOBILE_BREAKPOINT_THRESHOLD]: 2.5 },
        py: 1.5,
        borderBottom: `2px solid ${theme.palette.green}`,
      }}
    >
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="center"
        onClick={async () => {
          if (isLoading) {
            return;
          }
          try {
            trackClick();
            setLoading(true);
            await pushNotifications.manager.subscribe();
            trackEnabled();
          } finally {
            setLoading(false);
          }
        }}
        role="button"
        sx={{ flex: '1 1 0px', cursor: isLoading ? 'not-allowed' : 'pointer' }}
        tabIndex={0}
      >
        <BellFilledIcon fontSize="2rem" sx={{ color: theme.palette.green }} />
        <Typography sx={{ color: theme.palette.green, ml: 1.5 }} variant="body bold">
          Включите уведомления чтобы не пропустить важное
        </Typography>
      </Stack>

      <Button
        disabled={isLoading}
        onClick={() => {
          setClosed(true);
          isClosedGlobal = true;
        }}
        variant="text"
      >
        <CloseIcon sx={{ color: theme.palette.green }} />
      </Button>
    </Stack>
  );
};
